<template>
    <div class="components-order-offer-meal box p-2 is-width-100" v-if="visible" :class="{'has-background-success-light': amount > 0}">

      <div class="components-order-offer-meal__image" v-if="lunchMeal.image_thumbnail">
          <img :src="lunchMeal.image_thumbnail" :alt="lunchMeal.name"/>
      </div>

      <div class="components-order-offer-meal__content py-1 px-2 is-flex is-flex-direction-column is-height-100 is-justify-content-space-between">
          <div class="mb-0">
              <h4 class="is-size-6 has-text-black has-text-weight-bold mb-0">
                  <span v-if="amount > 0" class="has-text-success">{{ amount }}x</span>
                  {{ lunchMeal.name }}
              </h4>
            <p v-if="lunchMeal.portion" class="is-size-7 mt-1 mb-0">
                {{ lunchMeal.portion }}
            </p>
          </div>

          <div class="level is-mobile mt-2">
              <div class="level-left">

                <span class="level-item" v-if="lunchMeal.price > 0">
                  <span class="has-text-weight-bold" :class="{
                    'has-text-success': amount > 0,
                    'has-text-black': amount === 0
                  }">{{ price }}</span>
                  <span
                      v-if="lunchMeal.packaging_price"
                      class="tooltip is-tooltip-bottom mx-3"
                      :class="{'has-text-grey-light': amount === 0, 'has-text-success': amount > 0}"
                      :data-tooltip="'+ ' + packagingPrice"
                  >
                    <span class="icon icon--2"><i class="fas fa-box-open"></i></span>
                  </span>
                </span>

                <div class="buttons level-item">
                  <div class="is-flex is-align-items-center is-flex-direction-row mb-2">
                    <a
                        v-if="!soldOut && lunchMeal.price > 0"
                        class="button is-small is-success mb-0"
                        :class="{'is-light': amount === 0}"
                        @click="add"
                    >
                      <span class="icon icon--cart"><i class="fas fa-plus"></i></span>
                      <span>Přidat</span>
                    </a>

                    <button v-if="lunchMeal.price <= 0" class="button is-small mb-0" disabled>Nelze objednat</button>
                    <button v-if="soldOut" class="button is-small mb-0" disabled>Položka je nedostupná</button>

                    <a v-if="amount > 0" class="button is-small is-white mb-0 ml-2" @click="remove">
                      <span class="icon icon--cart"><i class="fas fa-trash"></i></span>
                      <span>Odebrat</span>
                    </a>
                  </div>
                </div>

              </div>

          </div>

      </div>

    </div>
</template>

<script>
import cartActions from '../../../store/web/cart/action-types';
import cartGetters from '../../../store/web/cart/getter-types';

export default {
  props: [
      'alwaysVisible',
      'lunchDayProps',
      'lunchMealProps',
      'soldOutProps',
  ],
  data() {
    return {
      lunchMeal: this.lunchMealProps,
      soldOut: this.soldOutProps,
      lunchDay: this.lunchDayProps
    }
  },
  methods: {
    add() {
        this.$store.dispatch('cart/' + cartActions.ADD_LUNCH_MEAL, {
          lunchMeal: this.lunchMeal,
          lunchDay: this.lunchDay
        }).then(({lunchMeal, soldOut}) => {
          this.lunchMeal = lunchMeal;
          this.soldOut = soldOut;
        });
    },
    remove() {
        this.$store.dispatch('cart/' + cartActions.REMOVE_LUNCH_MEAL, {
          lunchMeal: this.lunchMeal,
          lunchDay: this.lunchDay
        }).then(({lunchMeal, soldOut}) => {
          this.lunchMeal = lunchMeal;
          this.soldOut = soldOut;
        });
    }
  },
  computed: {
    cartLine() {
      return this.$store.getters['cart/' + cartGetters.GET_LUNCH_MEAL_CART_LINE]({
        lunchMeal: this.lunchMeal,
        lunchDay: this.lunchDay
      });
    },
    amount() {
      if (!this.cartLine) return 0;
      return this.cartLine.amount;
    },
    visible() {
      if (this.alwaysVisible) return true;
      return !!this.cartLine;
    },
    price() {
      if (!this.cartLine) return this.lunchMeal.price_formatted;
      return this.cartLine.price_formatted;
    },
    packagingPrice() {
      if (this.cartLine) return this.cartLine.packaging_price_formatted;
      return this.lunchMeal.packaging_price_formatted;
    },
  }
}
</script>

<style lang="sass">
</style>
